import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@sainsburys-tech/bolt';
import GoogleMap from '../../helpers/map';
import * as Styled from './StoreMap.styles';

var StoreMap = /*#__PURE__*/function (_Component) {
  _inherits(StoreMap, _Component);

  var _super = _createSuper(StoreMap);

  function StoreMap(props, context) {
    var _this;

    _classCallCheck(this, StoreMap);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "useInteractiveMap", function () {
      new Promise(function (resolve) {
        var googleMapInitTime = 500;
        setTimeout(function () {
          _this.map = new GoogleMap(_this.props.id, _this.props.mapSettings);
          resolve();
        }, googleMapInitTime);
      }).then(function () {
        var store = _this.props.store;
        var location = store.location;

        var googleApiFn = function googleApiFn() {
          return _this.setState({
            isInvalidMap: true
          });
        };

        _this.map.removeStorePins(googleApiFn);

        _this.map.addStorePin(store);

        _this.map.goToLocation(location.lat, location.lng);
      });
    });

    _this.map = null;
    _this.state = {
      isInvalidMap: false,
      isInteractiveMap: true
    };
    return _this;
  }

  _createClass(StoreMap, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isInteractiveMap = _this$state.isInteractiveMap,
          isInvalidMap = _this$state.isInvalidMap;
      var _this$props = this.props,
          store = _this$props.store,
          showErrorMsg = _this$props.showErrorMsg,
          ratio = _this$props.ratio,
          mapsKey = _this$props.mapsKey;

      if (!store) {
        if (isInteractiveMap) this.setState({
          isInteractiveMap: false
        });
        return null;
      }

      var location = store.location,
          type = store.type;

      if (isInteractiveMap && !isInvalidMap) {
        this.useInteractiveMap();
        return /*#__PURE__*/React.createElement(Styled.Container, {
          "data-test": "store-map"
        }, /*#__PURE__*/React.createElement(Styled.InteractiveMap, {
          ratio: ratio.toString()
        }, /*#__PURE__*/React.createElement(Styled.GoogleMap, {
          id: this.props.id,
          tabIndex: "-1"
        })));
      } // eslint-disable-next-line no-nested-ternary


      var storeType = type === 0 ? 'red' : type === 1 ? 'orange' : 'black';
      var icon = "https://media.4rgos.it/i/Argos/icon-pin-".concat(storeType, "_2.png?w=45"); // eslint-disable-next-line no-nested-ternary

      var ratioSize = ratio === '16-9' ? '640x360' : ratio === '4-3' ? '640x480' : '640x640';
      var mapImgSrc = "https://maps.googleapis.com/maps/api/staticmap?center=".concat(location.lat, ",").concat(location.lng, "&markers=icon:").concat(icon, "|").concat(location.lat, ",").concat(location.lng, "&zoom=16&size=").concat(ratioSize, "&key=").concat(mapsKey, "&channel=argos");
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.Container, {
        onClick: function onClick() {
          return _this2.setState({
            isInvalidMap: false,
            isInteractiveMap: true
          });
        },
        "data-test": "store map"
      }, /*#__PURE__*/React.createElement(Styled.InteractiveMap, {
        ratio: ratio.toString()
      }, /*#__PURE__*/React.createElement(Styled.MapText, null, "Click here to interact with the map"), /*#__PURE__*/React.createElement(Styled.StaticMapImage, {
        style: {
          backgroundImage: "url(".concat(mapImgSrc, ")")
        }
      }))), showErrorMsg && isInvalidMap && /*#__PURE__*/React.createElement(Alert, {
        style: {
          margin: '15px auto',
          width: '80%'
        },
        kind: "error",
        isCloseable: false,
        "data-test": "component-ss-alert"
      }, "Sorry, we are currently having some issues showing you the interactive map.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Please try again or check back later."));
    }
  }]);

  return StoreMap;
}(Component);

_defineProperty(StoreMap, "propTypes", {
  showErrorMsg: PropTypes.bool,
  mapSettings: PropTypes.shape({
    zoom: PropTypes.number,
    zoomControl: PropTypes.bool,
    mapTypeControl: PropTypes.bool,
    scaleControl: PropTypes.bool,
    streetViewControl: PropTypes.bool,
    rotateControl: PropTypes.bool,
    fullscreenControl: PropTypes.bool
  }),
  ratio: PropTypes.oneOf(['16-9', '4-3', '1-1']),
  store: PropTypes.shape({
    location: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    type: PropTypes.oneOf([0, 1, 2]),
    clickandcollect: PropTypes.bool
  }),
  id: PropTypes.string,
  mapsKey: PropTypes.string.isRequired
});

_defineProperty(StoreMap, "defaultProps", {
  showErrorMsg: false,
  id: 'map',
  ratio: '16-9',
  mapSettings: {
    zoom: 7,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false
  }
});

export { StoreMap as default };